// extracted by mini-css-extract-plugin
export default {"PanelView":"PanelView_PanelView__aJ-50","wrapper":"PanelView_wrapper__XCOBG"};